import {FC, useState} from 'react';
import clsx from 'clsx';
import {Link} from 'react-router-dom';
import {useLocation} from 'react-router';
import {checkIsActive, KTSVG, WithChildren} from '../../../../helpers';
import {useLayout} from '../../../core';
import styles from '../sidebar.module.scss';
import {SidebarTooltip} from './SidebarTooltip';
import Badge from 'react-bootstrap/Badge';


type Props = {
    to: string;
    title: string;
    icon?: string;
    fontIcon?: string;
    biIcon?: string;
    hasBullet?: boolean;
    hisPng?: boolean;
    exact?: boolean;
    activePaths?: string[];
    bgColor?: string;
    hasNewBadge?: boolean;
};

const SidebarMenuItem: FC<Props & WithChildren> = ({
    children,
    to,
    title,
    icon,
    fontIcon,
    biIcon,
    hasBullet = false,
    hisPng = false,
    exact = false,
    activePaths = [],
    bgColor,
    hasNewBadge=false
}) => {
    const {pathname} = useLocation();
    const isActive =
        (exact ? pathname === to : checkIsActive(pathname, to)) ||
        activePaths.some((path) => checkIsActive(pathname, path));
    const {config} = useLayout();
    const {app} = config;
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = (e: React.MouseEvent) => {
        if (children) {
            e.preventDefault();
            setIsOpen(!isOpen);
        }
    };

    return (
        <div className={clsx("menu-item", styles.menuItem, {'menu-accordion': children, 'show': isOpen})}>
            <Link
                className={clsx('menu-link without-sub', {active: isActive})}
                to={to}
                onClick={handleClick}
                style={bgColor ? {backgroundColor: bgColor} : undefined}
            >
                {hasBullet && (
                    <span className="menu-bullet">
                        <span className="bullet bullet-dot"></span>
                    </span>
                )}
                {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && !hisPng && (
                    <SidebarTooltip title={title}>
                        <span className="menu-icon">
                            <KTSVG path={icon} className="svg-icon-2" />
                        </span>
                    </SidebarTooltip>
                )}
                {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && !hisPng && (
                    <SidebarTooltip title={title}>
                        <i className={clsx('bi fs-3', fontIcon)}></i>
                    </SidebarTooltip>
                )}
                {biIcon && (
                    <SidebarTooltip title={title}>
                        <span className="menu-icon">
                            <i className={`bi ${biIcon} fs-4`}></i>
                        </span>
                    </SidebarTooltip>
                )}
                {hisPng && (
                    <SidebarTooltip title={title}>
                        <span className="menu-icon">
                            <span className="svg-icon svg-icon-2">
                                <img className="mh-50px" src={icon} alt="" width="17px" />
                            </span>
                        </span>
                    </SidebarTooltip>
                )}
                <span className="menu-title">{title}</span>
                {hasNewBadge && (<Badge bg="info">new</Badge> )}
                {children && (
                    <span className="menu-arrow"></span>
                )}
            </Link>
            {children && isOpen && (
              <div className="menu-sub menu-sub-accordion ps-2">
                {children}
              </div>
            )}
        </div>
    );
};

export {SidebarMenuItem};
